import React from 'react';

function About() {
  return (
    <div style={{ padding: '20px' }}>
      <h1>About Us</h1>
      <p>Redefining Global Spice Trade with purity and heritage.</p>
    </div>
  );
}

export default About;